// start:ng42.barrel
import './tuition-fees-dashboard.component';
// end:ng42.barrel

